/* 项目启动 */
import Vue from 'vue'
import App from './App'
import router from './router'
import Vue2Filters from 'vue2-filters'
import VueRouter from 'vue-router';

//import auth from './auth'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-default/index.css';
import DataTables from 'vue-data-tables'
import locale from 'element-ui/lib/locale/lang/en'

// Vue.use(ElementUI);
Vue.use(ElementUI, { locale })

Vue.use(DataTables)
Vue.use(Vue2Filters)


/* 
var VueResource = require('vue-resource');

Vue.use(VueResource);
 */

//Vue.prototype.$API_url = 'http://192.168.1.109:8090';

// Vue.prototype.$API_url = 'http://localhost/Coco/teacher/public';

Vue.prototype.$API_url = 'https://cococs.org/SlimAPI/public';
//Vue.prototype.$API_url = 'https://kimscard.com/SlimAPI/public';



new Vue({
  router: router,
  render: h => h(App)
  // components: { firstcomponent, secondcomponent }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js